var _g, _path, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
const SvgIconTurbo = props => /*#__PURE__*/React.createElement("svg", _extends({
  xmlns: "http://www.w3.org/2000/svg",
  width: 61,
  height: 61,
  fill: "none"
}, props), _g || (_g = /*#__PURE__*/React.createElement("g", {
  filter: "url(#icon-turbo_svg__a)"
}, /*#__PURE__*/React.createElement("circle", {
  cx: 30.282,
  cy: 27.782,
  r: 15.015,
  fill: "url(#icon-turbo_svg__b)"
}), /*#__PURE__*/React.createElement("circle", {
  cx: 30.282,
  cy: 27.782,
  r: 15.994,
  stroke: "#fff",
  strokeWidth: 1.958
}))), _path || (_path = /*#__PURE__*/React.createElement("path", {
  fill: "#fff",
  d: "M36.36 19.949c-2.607 0-6.102 1.788-8.45 4.862h-1.948c-1.406 0-2.212 1.05-2.768 2.16l-.745 1.487h3.513l1.823 1.824 1.823 1.823v3.512l1.487-.744c1.11-.554 2.16-1.362 2.16-2.768v-1.947c3.074-2.349 4.862-5.846 4.862-8.452v-1.757zm-3.105 3.647a1.216 1.216 0 1 1 0 2.43 1.216 1.216 0 0 1 0-2.43m-7.9 7.293-.608.608c-.878.878-1.216 3.039-1.216 3.039s2.064-.24 3.039-1.215l.607-.608z"
})), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
  id: "icon-turbo_svg__b",
  x1: 15.268,
  x2: 55.114,
  y1: 27.934,
  y2: 28.772,
  gradientUnits: "userSpaceOnUse"
}, /*#__PURE__*/React.createElement("stop", {
  stopColor: "#C830E1"
}), /*#__PURE__*/React.createElement("stop", {
  offset: 1,
  stopColor: "#FE4A25"
})), /*#__PURE__*/React.createElement("filter", {
  id: "icon-turbo_svg__a",
  width: 60.06,
  height: 60.06,
  x: 0.252,
  y: 0.363,
  colorInterpolationFilters: "sRGB",
  filterUnits: "userSpaceOnUse"
}, /*#__PURE__*/React.createElement("feFlood", {
  floodOpacity: 0,
  result: "BackgroundImageFix"
}), /*#__PURE__*/React.createElement("feColorMatrix", {
  in: "SourceAlpha",
  result: "hardAlpha",
  values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0"
}), /*#__PURE__*/React.createElement("feOffset", {
  dy: 2.611
}), /*#__PURE__*/React.createElement("feGaussianBlur", {
  stdDeviation: 6.528
}), /*#__PURE__*/React.createElement("feColorMatrix", {
  values: "0 0 0 0 0.921569 0 0 0 0 0.270588 0 0 0 0 0.14902 0 0 0 0.4 0"
}), /*#__PURE__*/React.createElement("feBlend", {
  in2: "BackgroundImageFix",
  result: "effect1_dropShadow_20508_13456"
}), /*#__PURE__*/React.createElement("feBlend", {
  in: "SourceGraphic",
  in2: "effect1_dropShadow_20508_13456",
  result: "shape"
})))));
export { SvgIconTurbo as ReactComponent };
export default __webpack_public_path__ + "static/media/icon-turbo.c9ac2f03.svg";